import * as CubeTree from '../../../cubeTree/index';
import Visit from '../../visit';
import Select from '../../select/index';
import { updateCubeList } from '../../../update/updateCubeList';
import { updateEnd } from '../../../update/updateEnd';
import { runForceUpdate } from '../../../update/runForceUpdate';

// 撤销
async function goodsDragMoveStackOut(stackOutItem: StackOutItem|null): Promise<void> {
    stackOutItem.data.forEach((moveTask: MoveTask): void => {
        let moveCubeIds: CubeId[] = getMoveCubes(moveTask);

        updateLogicParent(moveTask);
        Visit.Move.logic(moveTask.logic);
        Visit.Move.physics(moveTask.physics);
        Select.clear();
        Select.addGroup(moveCubeIds);
        Select.panelSelectAsync();
        moveUpadte(moveTask);
    });
}

// from 的 parent 有可能不准确(跨层板算法会调整父级指向)，需要临时更新一次 parent指向
function updateLogicParent(moveTask: MoveTask): void {
    moveTask.logic.forEach((logicTask: LogicMoveTask): void => {
        logicTask.from.parent = CubeTree.findParentIdByCubeId(logicTask.from.moveTarget);

        if (logicTask.to.insertBefore) {
            logicTask.to.parent = CubeTree.findParentIdByCubeId(logicTask.to.insertBefore);
        }
    });
}

function moveUpadte(moveTaskQueue: MoveTask): void {
    let physicsMoveUpdateList: CubeId[] = Visit.Move.physicsUpdateList(moveTaskQueue);
    let logicMoveUpdateList: CubeId[] = Visit.Move.logicUpdateList(moveTaskQueue, physicsMoveUpdateList);
    let updateList: CubeId[] = physicsMoveUpdateList.concat(logicMoveUpdateList);
    let forceUpdate: CubeId[] = Visit.Move.forceUpdateList(moveTaskQueue);

    updateCubeList(updateList);
    runForceUpdate(forceUpdate);
    updateEnd();
}

function getMoveCubes(moveTask: MoveTask): CubeId[] {
    let result: Set<CubeId> = new Set();

    moveTask.logic.forEach((logicTask: LogicMoveTask): void => {
        result.add(logicTask.to.moveTarget);
    });
    moveTask.physics.forEach((physicsTask: PhysicsMoveTask): void => {
        result.add(physicsTask.to.moveTarget);
    });

    return Array.from(result);
}

export {
    goodsDragMoveStackOut
};
